<template lang="pug">
.upload-documentos-table.col-12.cardContainer
    span.arquivos-complementares
        div.upload-arquivos
            p
                | {{ $t(tipoDocumento.nome) }}
                //- span(v-if="verificaObrigacao()" class="required-icon") *
            el-upload(
                action="#"
                :show-file-list='false'
                :auto-upload="false"
                :on-change="onLoadFileDoc"
                :on-remove="onRemoveFileDoc"
                :before-upload="antesUploadArquivo"
                :limit="1"
                :on-exceed="verificarLimite"
                :file-list="fileListDoc"
            )
                el-button.upload-button(type="primary")
                    i.el-icon-upload.mr-1
                    | {{ $t('mensagens.territorio.uploadArquivosVetoriaisParaguai') }}
        div.informacoes-arquivo(v-if='fileListDoc.length > 0')
            el-table(:data="fileListDoc" style="width: 100%")
                el-table-column(prop="name" :label='$t("mensagens.territorio.nomeArquivoDocumento")')
                el-table-column(align="center" prop="size" :label='$t("mensagens.territorio.tamanho")' width="180")
                    template(#default="scope")
                        | {{ scope.row.size === 0 ? '-' : (scope.row.size / 1024).toFixed(1) + ' kb' }}
                el-table-column(align="right")
                    template(#default="scope")
                        el-button(icon="el-icon-delete" size="small" type="danger" @click="onRemoveFileDoc(scope.row)")
</template>
<script>
import UploadHelp from '@/constants/UploadHelp';
import axios from 'axios';

export default {
    name: 'UploadDocumentos',

    props: {
        tipoDocumento: {
            type: Object,
            required: true
        },
        arquivosExistentes: {
            type: Array,
            default: () => []
        },
        cadastroEdicaoPessoas: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            fileListDoc: []
        };
    },

    watch: {
        arquivosExistentes: {
            handler(newValue) {
                this.initializeFileList();
            },
            deep: true
        }
    },

    mounted() {
        this.initializeFileList();
    },

    beforeDestroy() {
        this.limparListaArquivos();
    },

    methods: {
        initializeFileList() {
            if (this.arquivosExistentes.length > 0) {
                this.fileListDoc = this.arquivosExistentes
                .filter(file => file.idTipoArquivo === this.tipoDocumento.id)
                .map(file => ({
                    name: file.nomeArquivo,
                    idTipoArquivo: file.idTipoArquivo,
                    size: file.tamanho ? file.tamanho : 0,
                    uid: file.id
                }));
            } else {
                this.fileListDoc = [];
            }
        },
        limparListaArquivos() {
            this.fileListDoc = [];
        },
        async onLoadFileDoc(file, fileList) {
            const uploadPermitido = this.antesUploadArquivo(file);

            if (uploadPermitido === true && !this.cadastroEdicaoPessoas) {
                let url = process.env.VUE_APP_HTTP_PATH + '/territorio-arquivos/upload-temp';
                let formData = new FormData();
                const arquivoRenomeado = new File([file.raw], this.renomearArquivo(file.name), { type: file.raw.type });
                formData.append('file', arquivoRenomeado);
                const { data, status } = await axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (status === 200) {
                    this.fileListDoc = fileList.map(f => ({
                        ...f,
                        name: data,
                        idTipoArquivo: this.tipoDocumento.id
                    }));

                    this.$emit('update-file-list', { tipo: this.tipoDocumento, fileList: this.fileListDoc });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.erro.naoFoiPossivelEnviarArquivo')
                    });
                }
            } else if (uploadPermitido === true && this.cadastroEdicaoPessoas) {
                let url = process.env.VUE_APP_HTTP_PATH + '/representantes/upload-temp';
                let formData = new FormData();
                const arquivoRenomeado = new File([file.raw], this.renomearArquivo(file.name), { type: file.raw.type });
                formData.append('file', arquivoRenomeado);
                const { data, status } = await axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (status === 200) {
                    this.fileListDoc = fileList.map(f => ({
                        ...f,
                        name: data,
                        idTipoArquivo: this.tipoDocumento.id
                    }));

                    this.$emit('update-file-list', { tipo: this.tipoDocumento, fileList: this.fileListDoc });
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.erro.naoFoiPossivelEnviarArquivo')
                    });
                }
            } else {
                this.fileListDoc = this.fileListDoc.filter(l => l.uid !== file.uid);
                return false;
            }
        },
        async onRemoveFileDoc(file) {
            this.fileListDoc = this.fileListDoc.filter(
                l => l.uid !== file.uid
            );
            this.$emit('update-file-list', { tipo: this.tipoDocumento, fileList: this.fileListDoc });
            return true;
        },
        verificarLimite() {
            this.$notify.warning({
                message: this.$t('mensagens.territorio.notificacao.limiteDeArquivos')
            });
        },
        antesUploadArquivo(file) {
            const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!allowedExtensions.includes(fileExtension)) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.tiposPermitidosDocumentosParaguai')
                });
                return false;
            }
            if (file.size > UploadHelp.SIZE) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.ultrapassa15MB')
                });
                return false;
            }

            return true;
        },
        renomearArquivo(fileName) {
            const ultimoPonto = fileName.lastIndexOf('.');
            if (ultimoPonto === -1) {
                return this.removerAcentos(fileName);
            }

            const nome = fileName.substring(0, ultimoPonto);
            const extensao = fileName.substring(ultimoPonto);

            const novoNome = this.removerAcentos(nome);
            return novoNome + extensao;
        },
        removerAcentos(str) {
            return str.normalize('NFD').replace(/\p{Mn}/gu, '');
        }
        // verificaObrigacao() {
        //     if (this.tipoDocumento.id === 5 || this.tipoDocumento.id === 9) {
        //         return false;
        //     }
        //     return true;
        // }
    }
};
</script>
<style lang="scss">
.cardContainer {
    background-color: var(--white);
    width: 100%;
    border-radius: 5px;
    margin-top: 20px;
    padding: 20px;
}
.upload-arquivos {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    p {
        margin-right: 6.54rem;
    }
}
.el-upload-list__item-name {
    display: none;
}
.required-icon {
    padding-left: 5px;
    color: var(--red);
}
</style>
